// @ts-ignore
import { saveAs } from "file-saver";

const saveImage = (base64: string) => {
  saveAs(base64, `건강성적표.png`);
};

export default saveImage;
